export type Connection<T> = {
    readonly edges: readonly ({ node: T | null } | null)[] | null;
} | null;

export type ConnectionItem<T> = NonNullable<T> extends Connection<infer R> ? R : string;

export const flattenConnectionNodes = <T>(connection?: Connection<T>): T[] => {
    const edges = connection?.edges || [];
    return edges.reduce<T[]>((acc, edge) => (edge?.node ? acc.concat(edge.node) : acc), []);
};
